import actions from "~/shared/actions/app";
import * as server from "~/shared/api/server";
import type { Config } from "~/shared/api/useConfig";

export function logout(config: Config) {
	window.sessionStorage.clear();
	return (dispatch) =>
		server.logout(config).then((json) => {
			const url = json.logoutUrl;
			dispatch(actions.logout(url));
			window.location.href = url;
		});
}

export function toggleUserMenu() {
	return (dispatch) => dispatch(actions.toggleUserMenu());
}

export function canGoBack() {
	return (dispatch) => dispatch(actions.canGoBack());
}

export function setReturnUrl(url: string) {
	return (dispatch) => dispatch(actions.setReturnUrl(url));
}
